import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
} from '@angular/common/http';
import { Observable, of } from 'rxjs';

@Injectable()
export class OnboardingMockInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Only intercept the onboarding endpoint
    if (req.method === 'GET' && req.url.endsWith('/onboarding/v2')) {
      const mockResponse = {
        result: { code: 'SERVICE_OK' },
        items: [
          { key: 'onboarding_welcome', order: 0 },
          {
            key: 'credit',
            order: 1,
            fallback: {
              key: 'survey',
              route: 'money_emergency_survey'
            }
          },
          { key: 'survey', route: 'money_emergency_survey', order: 2 },
          { key: 'fa_intro', order: 3 }
        ]
      };

      return of(new HttpResponse({ status: 200, body: mockResponse }));
    }

    // Let all other requests through
    return next.handle(req);
  }
}
